<template>
  <div id="edu-notice-box">
    <div class="notice-content">
      <div :class="['title' , type]">
        <img src="@/assets/images/theme1/common/notification.png" alt="notification">
      </div>
      <div class="content">
        <div class="mas-title">
          {{ title }}
        </div>
        <div class="msg-text">
          <div>{{ contentTitle }}</div>
          <div class="msg">
            {{ content }}
          </div>
          <div class="msg-footer">
            <div>大连爱丁云教育</div>
            <div>{{ time }}</div>
          </div>
        </div>
      </div>
    </div>
    <img class="close-notice" src="@/assets/images/theme1/common/close-notice.png" @click="hide()">
  </div>
</template>

<script>
export default {
  name: "eduNoticeBox",
  props: {
    // 标题
    title: {
      type: String,
      default: '通知'
    },
    // 内容标题
    contentTitle: {
      type: String,
      default: '尊敬的各位老师：'
    },
    // 内容
    content: {
      type: String,
      default: ''
    },
    // 时间
    time: {
      type: String,
      default: ''
    },
    // 标题背景色
    type: {
      default: 'primary',
      validator: (value) => {
        return [
          'primary',
          'success',
          'warning',
          'danger'
        ].includes(value);
      }
    }
  },
  methods: {
    hide() {
      this.$eduNoticeBox.hide();
    }
  }
}
</script>

<style lang="scss" scoped>
#edu-notice-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .notice-content {
    width: 530px;
    height: 545px;
    border-radius: 20px;

    .title {
      height: 140px;
      border-radius: 20px 20px 0 0;
      background-color: #4B54DE;
      display: flex;
      align-items: center;
      justify-content: center;

      &.primary {
        background-color: #4B54DE;
      }

      &.success {
        background-color: #67c23a;
      }

      &.warning {
        background-color: #e6a23c;
      }

      &.danger {
        background-color: #f56c6c;
      }

      img {
        display: block;
      }
    }

    .content {
      height: 405px;
      background-color: white;
      border-radius: 0 0 20px 20px;

      .mas-title {
        font-size: 28px;
        height: 80px;
        line-height: 80px;
        color: rgba(16, 16, 16, 100);
        font-weight: bold;
        text-align: center;
      }

      .msg-text {
        font-size: 20px;
        height: calc(405px - 80px);
        overflow: auto;
        padding: 0 20px 20px 20px;
        position: relative;

        .msg {
          text-indent: 30px;

          .text-blob {
            font-weight: bold;
          }
        }

        .msg-footer {
          position: absolute;
          right: 20px;
          bottom: 20px;
        }
      }
    }
  }

  .close-notice {
    display: block;
    width: 60px;
    margin-top: 20px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/eduUI/eduNoticeBox/eduNoticeBox.vue